import { useSession } from "@/account/lib/auth-client";
import { useEffect } from "react";

export function ProtectedRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data: session, isPending } = useSession();

  useEffect(() => {
    if (!isPending && !session) {
      const currentPath = window.location.pathname + window.location.search;
      // Redirect to local login route with return path
      window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
    }
  }, [session, isPending]);

  if (isPending) {
    return (
      <div className="flex h-screen items-center justify-center bg-obsidian">
        <div className="text-silica">Loading...</div>
      </div>
    );
  }

  if (!session) {
    return (
      <div className="flex h-screen items-center justify-center bg-obsidian">
        <div className="text-silica">Redirecting to login...</div>
      </div>
    );
  }

  return <>{children}</>;
}
